import React from "react";

import { CompanyAddress } from '../Company/Company';

import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';

import { PaymentType } from '../../Utilities/Enums/PaymentTypeEnum';
import { BillingStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { CurrencyEnum } from '../../Utilities/Enums/CurrencyEnums';
import { ValidityTypeEnum } from '../../Utilities/Enums/ValidityTypeEnums';

import { CheckoutField, ListBillingField, InvoiceField, BillingDetailsField, BillingAddressField, DetailsInvoiceField, BillingLicenseDetailsField, BillingPaymentField, CheckoutDataField } from '../../Utilities/Enums/ParametersEnum';

export class Billing {
    id: number = 0;
    invoiceNo: string = "";
    invoiceDate?: string | Date | null = null;
    billedCompany: string = "";
    amount: number = 0;
    generatedLicense: string = "";
    status: number = 0;
    createdAt?: string | Date | null = null;
    updatedAt?: string | Date | null = null;

    constructor(obj?: Partial<Billing>) {
        Object.assign(this, obj);
    }
}

export class ListBilling {
    [ListBillingField.COMPANY_NAME]?: string = "";
    [ListBillingField.CREATED_DATE]?: string | Date | null = null;
    [ListBillingField.GENERATED_LICENSE_KEY]?: string = "";
    [ListBillingField.INVOICE_DATE]?: string | Date | null = null;
    [ListBillingField.PUBLIC_ID]?: string | number = "";
    [ListBillingField.STATUS]?: number = 0;
    [ListBillingField.TOTAL_AFTER_ADJUSTMENT]?: number = 0;
    [ListBillingField.TRANS_NO]?: string | number = "";
    [ListBillingField.UPDATED_DATE]?: string | Date | null = null;
    [ListBillingField.CURRENCY_CODE]?: CurrencyEnum = CurrencyEnum.PHP;

    constructor(obj?: Partial<ListBilling>) {
        Object.assign(this, obj);
    }
}

export class BillingCheckout {
    [CheckoutField.PUBLIC_ID]: string | number = 0;
    [CheckoutField.COMPANY_NAME]?: string = "";
    [CheckoutField.COMPANY_PUBLIC_ID]?: string | number = "";
    [CheckoutField.CONTACT_PERSON]?: string = "";
    [CheckoutField.CONTACT_PHONE]?: string = "";
    [CheckoutField.EMAIL]?: string = "";
    [CheckoutField.ADDRESS]: CompanyAddress = new CompanyAddress();
    [CheckoutField.PAYMENT_TYPE]?: PaymentType = 0;
    [CheckoutField.BANK]?: string | number = 0;
    [CheckoutField.CARD_ACCOUNT_NAME]?: string = "";
    [CheckoutField.CARD_NUMBER]?: string = "";
    [CheckoutField.CARD_EXPIRATION]?: string | Date | null = null;
    [CheckoutField.CVV]?: string | number = "";
    [CheckoutField.E_WALLET]?: number = 0;

    [CheckoutField.SUB_TOTAL]?: number = 0;
    [CheckoutField.DISCOUNT_AMOUNT]?: number = 0;
    [CheckoutField.TAX_PERCENT]?: number = 8;
    [CheckoutField.TAX_AMOUNT]?: number = 0;
    [CheckoutField.GRAND_TOTAL]?: number = 0;

    [CheckoutField.LICENSE_KEY]?: string = "";
    [CheckoutField.INVOICE_NO]?: string = "";

    [CheckoutField.STATUS]: number = 0;
    [CheckoutField.UPDATED_DATE]?: string | Date | null = null;
    [CheckoutField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<BillingCheckout>) {
        Object.assign(this, obj);
    }
}

export class Invoice {
    [InvoiceField.LINE_TOTAL]?: number = 0;
    [InvoiceField.SUB_TOTAL]?: number = 0;
    [InvoiceField.TAX_RATE]?: number = 8;
    [InvoiceField.TAX_AMOUNT]?: number = 0;
    [InvoiceField.TOTAL_BEFORE_ADJUSTMENT]?: number = 0;
    [InvoiceField.ROUND_ADJUSTMENT]?: number = 0;
    [InvoiceField.TOTAL_AFTER_ADJUSTMENT]?: number = 0;
    [InvoiceField.IS_WITH_ANNUAL_DISCOUNT]?: boolean = false;
    [InvoiceField.ANNUAL_DISCOUNT_AMOUNT]?: number = 0;
    [InvoiceField.ANNUAL_DISCOUNT_RATE]?: number = 0;
    [InvoiceField.BILLING_DETAILS]?: BillingDetails = new BillingDetails();

    [InvoiceField.PUBLIC_ID]: string | number = 0;
    [InvoiceField.DISCOUNT_AMOUNT]?: number = 0;
    [InvoiceField.CURRENCY_CODE]?: CurrencyEnum = GlobalFunctionHelper.getCurrencyCode() ?? CurrencyEnum.PHP;

    constructor(obj?: Partial<Invoice>) {
        Object.assign(this, obj);
    }
}

export class DetailsInvoice {
    [DetailsInvoiceField.ANNUAL_DISCOUNT_AMOUNT]?: number = 0;
    [DetailsInvoiceField.ANNUAL_DISCOUNT_RATE]?: number = 0;
    [DetailsInvoiceField.BILLING_DETAILS]?: BillingDetails = new BillingDetails();
    [DetailsInvoiceField.IS_WITH_ANNUAL_DISCOUNT]?: boolean = false;
    [DetailsInvoiceField.LICENSE_DETAILS]?: BillingLicenseDetails = new BillingLicenseDetails();
    [DetailsInvoiceField.LINE_TOTAL]?: number = 0;
    [DetailsInvoiceField.PAYMENT]?: BillingPayment = new BillingPayment();
    [DetailsInvoiceField.PUBLIC_ID]?: string | number = 0;
    [DetailsInvoiceField.ROUND_ADJUSTMENT]?: number = 0;
    [DetailsInvoiceField.SUB_TOTAL]?: number = 0;
    [DetailsInvoiceField.TAX_AMOUNT]?: number = 0;
    [DetailsInvoiceField.TAX_RATE]?: number = 8;
    [DetailsInvoiceField.TOTAL_AFTER_ADJUSTMENT]?: number = 0;
    [DetailsInvoiceField.TOTAL_BEFORE_ADJUSTMENT]?: number = 0;
    [DetailsInvoiceField.USER_CAPACITY_DISCOUNT_AMOUNT]?: number = 0;
    [DetailsInvoiceField.USER_CAPACITY_DISCOUNT]?: number = 0;
    
    [DetailsInvoiceField.TRANS_NO]?: string | number | null = null;
    [DetailsInvoiceField.STATUS]?: BillingStatusEnum = 0;
    [DetailsInvoiceField.CREATED_DATE]?: string | Date | null = null;
    [DetailsInvoiceField.INVOICE_DATE]?: string | Date | null = null;
    [DetailsInvoiceField.UPDATED_DATE]?: string | Date | null = null;
    [DetailsInvoiceField.GENERATED_LICENSE_KEY]?: string | number = '';
    [DetailsInvoiceField.GENERATED_LICENSE_PUBLIC_ID]?: string | number = 0;
    [DetailsInvoiceField.REMARKS]?: any = null;
    [DetailsInvoiceField.PENDING_ID]?: string | number | null = null;
    [DetailsInvoiceField.COMPANY_PUBLIC_ID]?: string | number = 0;
    [DetailsInvoiceField.DISCOUNT_AMOUNT]?: number = 0;
    [DetailsInvoiceField.CURRENCY_CODE]?: CurrencyEnum = GlobalFunctionHelper.getCurrencyCode() ?? CurrencyEnum.PHP;

    constructor(obj?: Partial<DetailsInvoice>) {
        Object.assign(this, obj);
    }
}

export class BillingLicenseDetails {
    [BillingLicenseDetailsField.LICENSE_TYPE]?: number = 0;
    [BillingLicenseDetailsField.STORAGE_CAPACITY]?: number = 0;
    [BillingLicenseDetailsField.USER_CAPACITY]?: number = 0;
    [BillingLicenseDetailsField.VALIDITY]: number = 0;
    [BillingLicenseDetailsField.VALIDITY_TYPE]: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [BillingLicenseDetailsField.ISSUE_DATE]?: string | Date | null = null;
    [BillingLicenseDetailsField.EXPIRY_DATE]?: string | Date | null = null;
    [BillingLicenseDetailsField.STATUS]?: BillingStatusEnum = 0;
    [BillingLicenseDetailsField.MODULES]?: string[] = [];
    
    constructor(obj?: Partial<BillingLicenseDetails>) {
        Object.assign(this, obj);
    }
}

export class BillingPayment {
    [BillingPaymentField.AMOUNT_PAID]?: number = 0;
    [BillingPaymentField.CURRENCY]?: string = '';
    [BillingPaymentField.PAYMENT_DATE]?: string | Date | null = null;
    [BillingPaymentField.PROVIDER]?: string = '';
    [BillingPaymentField.STATUS]?: BillingStatusEnum = 0;
    [BillingPaymentField.TRANSACTION_ID]?: string = '';

    [BillingPaymentField.CARD_BRAND]?: string = '';
    [BillingPaymentField.LAST_4_CARD_DIGIT]?: string = '';
    [BillingPaymentField.PAYMENT_METHOD_ID]?: string = '';
    [BillingPaymentField.PAYMENT_TYPE]?: string = '';
    [BillingPaymentField.REMARKS]?: string = '';
    
    constructor(obj?: Partial<BillingPayment>) {
        Object.assign(this, obj);
    }
}

export class BillingDetails {
    [BillingDetailsField.NAME]?: string = "";
    [BillingDetailsField.CONTACT_PERSON]?: string = "";
    [BillingDetailsField.CONTACT_PHONE]?: string = "";
    [BillingDetailsField.EMAIL]?: string = "";
    [BillingDetailsField.ADDRESS]?: BillingAddress = new BillingAddress();
    [BillingDetailsField.COMPANY_PUBLIC_ID]?: string | number = 0;
    
    constructor(obj?: Partial<BillingDetails>) {
        Object.assign(this, obj);
    }
}

export class BillingAddress {
    [BillingAddressField.ADDRESS_TYPE]: number = 0;
    [BillingAddressField.CITY]: string = "";
    [BillingAddressField.COUNTRY]: string = "";
    [BillingAddressField.FULL_ADDRESS]: string = "";
    [BillingAddressField.STATE]: string = "";
    [BillingAddressField.STREET_ADDRESS]: string = "";
    [BillingAddressField.ZIP_CODE]: string = "";

    constructor(obj?: Partial<BillingAddress>) {
        Object.assign(this, obj);
    }
}

export class BillDetailsInterface {
    billingid?: string | number;
    viewType?: ViewType;
    setviewType?: React.Dispatch<React.SetStateAction<ViewType>>;
    formData?: DetailsInvoice;
    setformData?: React.Dispatch<React.SetStateAction<DetailsInvoice>>;
    previewData?: DetailsInvoice;
    setpreviewData?: React.Dispatch<React.SetStateAction<DetailsInvoice>>;
    errorMessages?: any;
    setErrorMessages?: React.Dispatch<React.SetStateAction<any>>;
    computeBillAmounts?: (e: any) => void = (e: any) =>{};
    printBillRef?: any;
    isPrint?: boolean;

    constructor(obj?: Partial<BillDetailsInterface>) {
        Object.assign(this, obj);
    }
}


export class CheckoutData {
    [CheckoutDataField.BILLING_DETAILS]?: BillingDetails = new BillingDetails();

    [CheckoutDataField.VALIDITY]?: number = 0;
    [CheckoutDataField.VALIDITY_TYPE]?: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [CheckoutDataField.MODULES]?: string[] = [];
    [CheckoutDataField.USER_CAPACITY]?: number = 0;
    [CheckoutDataField.STORAGE_CAPACITY]?: number = 0;

    [CheckoutDataField.LINE_TOTAL]?: number = 0;
    [CheckoutDataField.SUB_TOTAL]?: number = 0;
    [CheckoutDataField.TAX_RATE]?: number = 0;
    [CheckoutDataField.TAX_AMOUNT]?: number = 0;
    [CheckoutDataField.TOTAL_BEFORE_ADJUSTMENT]?: number = 0;
    [CheckoutDataField.ROUND_ADJUSTMENT]?: number = 0;
    [CheckoutDataField.TOTAL_AFTER_ADJUSTMENT]?: number = 0;
    [CheckoutDataField.DISCOUNT_AMOUNT]?: number = 0;
    [CheckoutDataField.CURRENCY_CODE]?: CurrencyEnum = GlobalFunctionHelper.getCurrencyCode() ?? CurrencyEnum.PHP;

    constructor(obj?: Partial<CheckoutData>) {
        Object.assign(this, obj);
    }
}